import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

export const omnibarActionParam = 'omnibarAction';

export enum ServiceProviderOmnibarAction {
  CreateMedicalRequest = 'create-medical-request',
  CreateMedicalCorrespondence = 'create-medical-correspondence',
  RegisterUseOfForce = 'register-use-of-force',
  RequestUseOfForceAuthorization = 'request-use-of-force-authorization',
  CreateForumChat = 'create-forum-chat',
  CreateSurvey = 'create-survey',
}

// The parameter is removed before the action runs, so reloading or going back does not start it again.
export function useOmnibarAction(
  action: ServiceProviderOmnibarAction,
  run: () => void,
  isReady = true
) {
  const location = useLocation();
  const history = useHistory();
  const isRequested =
    new URLSearchParams(location.search).get(omnibarActionParam) === action;

  useEffect(() => {
    if (!isRequested || !isReady) return;
    const params = new URLSearchParams(location.search);
    params.delete(omnibarActionParam);
    history.replace({ ...location, search: params.toString() });
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRequested, isReady]);
}
